<template>
  <v-container>
    <v-row dense>
      <v-col>
        <v-text-field label="Vyhladat"></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="admin" dense>
      <v-col align="right">
        <v-btn small color="success" @click="createPollCategory()">Nová RUBRIKA</v-btn>
      </v-col>
    </v-row>

    <v-progress-linear v-if="categoriesState.loading" data-test="categories-loading"
      indeterminate></v-progress-linear>
    <v-alert v-if="categoriesState.error" dense type="error">
      Rubriky sa nepodarilo načítať.
      <v-btn data-test="categories-retry" text x-small @click="getCategories(true)">Skúsiť znova</v-btn>
    </v-alert>

    <v-row dense>
      <v-col>
        <v-expansion-panels multiple hover>

          <v-expansion-panel v-for="category in categories" v-bind:key="category.id"
            @change="onCategoryToggle(category.id)">
            <v-expansion-panel-header><strong>{{ category.order }}. {{ category.name }} (ID {{ category.id }})<v-icon
                  v-show="!category.active">mdi-eye-outline</v-icon><v-icon
                  v-show="category.private">mdi-file-hidden</v-icon></strong><v-spacer></v-spacer>
              RUBRIKA</v-expansion-panel-header>
            <v-expansion-panel-content>

              <poll-category-detail :admin="admin" :itemID="category.id"
                @sync-child="getCategories(true)"></poll-category-detail>
              <v-progress-linear v-if="branchLoading('polls', category.id)"
                :data-test="'polls-loading-' + category.id" indeterminate></v-progress-linear>
              <v-alert v-if="branchError('polls', category.id)" dense type="error">
                Kategórie sa nepodarilo načítať.
                <v-btn :data-test="'polls-retry-' + category.id" text x-small
                  @click="loadPolls(category.id, true)">Skúsiť znova</v-btn>
              </v-alert>
              <v-expansion-panels multiple hover>
                <v-expansion-panel v-for="poll in pollItems(category)" v-bind:key="poll.id"
                  @change="onPollToggle(poll.id)">
                  <v-expansion-panel-header><strong>{{ poll.order }}. {{ poll.name }} (ID {{ poll.id }})<v-icon
                        v-show="!poll.active">mdi-eye-outline</v-icon><v-icon
                        v-show="poll.private">mdi-file-hidden</v-icon></strong> <v-spacer></v-spacer>
                    KATEGÓRIA</v-expansion-panel-header>
                  <v-expansion-panel-content>

                    <poll-detail :admin="admin" :itemID="poll.id"
                      @sync-child="syncPollDetail(category.id, $event)"></poll-detail>
                    <v-progress-linear v-if="branchLoading('questions', poll.id)"
                      :data-test="'questions-loading-' + poll.id" indeterminate></v-progress-linear>
                    <v-alert v-if="branchError('questions', poll.id)" dense type="error">
                      Ankety sa nepodarilo načítať.
                      <v-btn :data-test="'questions-retry-' + poll.id" text x-small
                        @click="loadQuestions(poll.id, true)">Skúsiť znova</v-btn>
                    </v-alert>

                    <v-expansion-panels multiple hover>
                      <v-expansion-panel v-for="question in questionItems(poll)" v-bind:key="question.id"
                        @change="onQuestionToggle(question.id)">
                        <v-expansion-panel-header><strong>{{ question.order }}. {{ question.first_field }} {{
                          question.second_field }} <v-icon v-show="!question.active">mdi-eye-outline</v-icon></strong>
                          <v-spacer></v-spacer> ANKETA</v-expansion-panel-header>
                        <v-expansion-panel-content>


                          <poll-question-detail :admin="admin" :itemID="question.id"
                            @sync-child="syncQuestionDetail('questions', poll.id, $event)"></poll-question-detail>
                          <v-progress-linear v-if="branchLoading('subQuestions', question.id)"
                            :data-test="'sub-questions-loading-' + question.id" indeterminate></v-progress-linear>
                          <v-alert v-if="branchError('subQuestions', question.id)" dense type="error">
                            Podankety sa nepodarilo načítať.
                            <v-btn :data-test="'sub-questions-retry-' + question.id" text x-small
                              @click="loadSubQuestions(question.id, true)">Skúsiť znova</v-btn>
                          </v-alert>

                          <v-expansion-panels multiple hover>
                            <v-expansion-panel v-for="subQuestion in subQuestionItems(question)"
                              v-bind:key="subQuestion.id">
                              <v-expansion-panel-header><strong>{{ subQuestion.order }}. {{ subQuestion.first_field }}
                                  {{ subQuestion.second_field }} <v-icon
                                    v-show="!subQuestion.active">mdi-eye-outline</v-icon></strong> <v-spacer></v-spacer>
                                PODANKETA</v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <poll-question-detail :admin="admin" :itemID="subQuestion.id"
                                  @sync-child="syncQuestionDetail('subQuestions', question.id, $event)"></poll-question-detail>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                          <v-row dense>
                            <v-col align="right">
                              <v-btn small color="success" @click="createPollSubQuestion(question.id)">Nová PODANKETA</v-btn>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <v-row dense>
                      <v-col align="right">
                        <v-btn small color="success" @click="createPollQuestion(poll.id)">Nová ANKETA</v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-row dense>
                <v-col align="right">
                  <v-btn small color="success" @click="createPoll(category.id)">Nová KATEGÓRIA</v-btn>
                </v-col>
              </v-row>

            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>
import { APIService } from "@/http/APIService.js";
import PollCategoryDetail from "./PollCategoryDetail.vue";
import PollDetail from "./PollDetail.vue";
import PollQuestionDetail from "./PollQuestionDetail.vue";

// import { mapGetters } from "vuex";

const apiService = new APIService();

export default {

  components: {
    PollCategoryDetail,
    PollDetail,
    PollQuestionDetail
  },

  props: {
    admin: { type: Boolean, required: false, default: true },
  },

  data() {
    return {
      categories: [],
      categoriesState: {
        loading: false,
        loaded: false,
        error: null,
        generation: 0,
        promise: null,
      },
      branches: {
        polls: {},
        questions: {},
        subQuestions: {},
      },
    }
  },

  mounted() {
    this.getCategories().catch(() => {});
  },

  methods: {
    getCategories(force = false) {
      if (this.categoriesState.loading && !force) {
        return this.categoriesState.promise;
      }

      const generation = this.categoriesState.generation + 1;
      this.$set(this.categoriesState, 'generation', generation);
      this.$set(this.categoriesState, 'loading', true);
      this.$set(this.categoriesState, 'error', null);

      const promise = Promise.resolve().then(() => (
        this.admin === true
          ? apiService.getGeneralPollCategoriesAdmin(['order'], '', 0, 0, [])
          : apiService.getGeneralPollCategoriesModerator('', '', 0, 0, [])
      )).then(response => {
        if (generation !== this.categoriesState.generation) {
          return this.categories;
        }
        this.pruneRemovedBranches('categories', this.categories, response.results);
        this.categories = response.results;
        this.$set(this.categoriesState, 'loaded', true);
        this.$set(this.categoriesState, 'loading', false);
        this.$set(this.categoriesState, 'promise', null);
        return this.categories;
      }).catch(error => {
        if (generation === this.categoriesState.generation) {
          this.$set(this.categoriesState, 'error', error);
          this.$set(this.categoriesState, 'loading', false);
          this.$set(this.categoriesState, 'promise', null);
        }
        throw error;
      });

      this.$set(this.categoriesState, 'promise', promise);
      return promise;
    },
    branchState(type, parentID) {
      if (!this.branches[type][parentID]) {
        this.$set(this.branches[type], parentID, {
          items: [],
          loading: false,
          loaded: false,
          error: null,
          generation: 0,
          promise: null,
          preserveRemovedIDs: {},
        });
      }
      return this.branches[type][parentID];
    },
    branchItems(type, parentID) {
      const branch = this.branches[type][parentID];
      return branch ? branch.items : [];
    },
    branchLoading(type, parentID) {
      const branch = this.branches[type][parentID];
      return branch ? branch.loading : false;
    },
    branchError(type, parentID) {
      const branch = this.branches[type][parentID];
      return branch ? branch.error : null;
    },
    branchActive(type, parentID) {
      const branch = this.branches[type][parentID];
      return branch ? branch.loaded || branch.loading : false;
    },
    loadBranch(
      type,
      parentID,
      request,
      force = false,
      preserveRemovedIDs = [],
      belongsToParent = () => true,
    ) {
      const branch = this.branchState(type, parentID);
      preserveRemovedIDs.forEach(id => {
        if (id != null) {
          this.$set(branch.preserveRemovedIDs, String(id), true);
        }
      });

      if (branch.loaded && !force) {
        return branch.items;
      }
      if (branch.loading && !force) {
        return branch.promise;
      }

      const generation = branch.generation + 1;
      this.$set(branch, 'generation', generation);
      this.$set(branch, 'loading', true);
      this.$set(branch, 'error', null);

      const promise = Promise.resolve().then(request).then(response => {
        if (generation !== branch.generation) {
          return branch.items;
        }
        const nextItems = response.results.filter(belongsToParent);
        const previousIDs = new Set(branch.items.map(item => String(item.id)));
        const nextIDs = new Set(nextItems.map(item => String(item.id)));
        const persistentPreserveRemovedIDs = Object.keys(branch.preserveRemovedIDs);
        this.pruneRemovedBranches(
          type,
          branch.items,
          nextItems,
          persistentPreserveRemovedIDs,
        );
        persistentPreserveRemovedIDs
          .filter(id => previousIDs.has(id) && !nextIDs.has(id))
          .forEach(id => this.$delete(branch.preserveRemovedIDs, id));
        this.$set(branch, 'items', nextItems);
        this.$set(branch, 'loaded', true);
        this.$set(branch, 'loading', false);
        this.$set(branch, 'promise', null);
        return branch.items;
      }).catch(error => {
        if (generation === branch.generation) {
          this.$set(branch, 'error', error);
          this.$set(branch, 'loading', false);
          this.$set(branch, 'promise', null);
        }
        throw error;
      });

      this.$set(branch, 'promise', promise);
      return promise;
    },
    loadPolls(categoryID, force = false, preserveRemovedIDs = []) {
      return this.loadBranch(
        'polls', categoryID,
        () => apiService.getGeneralPollsAdmin(['order'], '', 0, 0, [['poll_category', categoryID]]),
        force,
        preserveRemovedIDs,
        item => String(item.poll_category) === String(categoryID),
      );
    },
    loadQuestions(pollID, force = false, preserveRemovedIDs = []) {
      return this.loadBranch(
        'questions', pollID,
        () => apiService.getGeneralPollQuestionsAdmin(['order'], '', 0, 0, [['poll', pollID]]),
        force,
        preserveRemovedIDs,
        item => String(item.poll) === String(pollID),
      );
    },
    loadSubQuestions(questionID, force = false, preserveRemovedIDs = []) {
      return this.loadBranch(
        'subQuestions', questionID,
        () => apiService.getGeneralPollQuestionsAdmin(['order'], '', 0, 0, [['parent_question', questionID]]),
        force,
        preserveRemovedIDs,
        item => String(item.parent_question) === String(questionID),
      );
    },
    onCategoryToggle(categoryID) {
      if (this.admin === true) {
        return this.loadPolls(categoryID);
      }
    },
    onPollToggle(pollID) {
      if (this.admin === true) {
        return this.loadQuestions(pollID);
      }
    },
    onQuestionToggle(questionID) {
      if (this.admin === true) {
        return this.loadSubQuestions(questionID);
      }
    },
    pollItems(category) {
      return this.admin === true ? this.branchItems('polls', category.id) : (category.polls || []);
    },
    questionItems(poll) {
      return this.admin === true ? this.branchItems('questions', poll.id) : (poll.questions || []);
    },
    subQuestionItems(question) {
      return this.admin === true
        ? this.branchItems('subQuestions', question.id)
        : (question.sub_questions || []);
    },
    syncPollDetail(sourceCategoryID, savedPoll) {
      if (this.admin !== true) {
        return this.getCategories(true);
      }

      const destinationCategoryID = savedPoll && savedPoll.poll_category;
      const destinationChanged = destinationCategoryID != null
        && String(destinationCategoryID) !== String(sourceCategoryID);
      if (destinationChanged && savedPoll.id != null) {
        const destinationBranch = this.branches.polls[destinationCategoryID];
        if (destinationBranch) {
          this.$delete(destinationBranch.preserveRemovedIDs, String(savedPoll.id));
        }
      }
      const sourceRefresh = destinationChanged && savedPoll.id != null
        ? this.loadPolls(sourceCategoryID, true, [savedPoll.id])
        : this.loadPolls(sourceCategoryID, true);
      if (destinationChanged && this.branchActive('polls', destinationCategoryID)) {
        return Promise.all([
          sourceRefresh,
          this.loadPolls(destinationCategoryID, true),
        ]);
      }
      return sourceRefresh;
    },
    syncQuestionDetail(sourceType, sourceParentID, savedQuestion) {
      if (this.admin !== true) {
        return this.getCategories(true);
      }

      let destinationType = null;
      let destinationParentID = null;
      if (savedQuestion && savedQuestion.parent_question != null) {
        destinationType = 'subQuestions';
        destinationParentID = savedQuestion.parent_question;
      } else if (savedQuestion && savedQuestion.poll != null) {
        destinationType = 'questions';
        destinationParentID = savedQuestion.poll;
      }

      const destinationChanged = destinationParentID != null
        && (destinationType !== sourceType
          || String(destinationParentID) !== String(sourceParentID));
      const preserveRemovedIDs = destinationChanged && savedQuestion.id != null
        ? [savedQuestion.id]
        : [];
      if (destinationChanged && savedQuestion.id != null) {
        const destinationBranch = this.branches[destinationType][destinationParentID];
        if (destinationBranch) {
          this.$delete(destinationBranch.preserveRemovedIDs, String(savedQuestion.id));
        }
      }
      let sourceRefresh;
      if (sourceType === 'questions') {
        sourceRefresh = preserveRemovedIDs.length
          ? this.loadQuestions(sourceParentID, true, preserveRemovedIDs)
          : this.loadQuestions(sourceParentID, true);
      } else {
        sourceRefresh = preserveRemovedIDs.length
          ? this.loadSubQuestions(sourceParentID, true, preserveRemovedIDs)
          : this.loadSubQuestions(sourceParentID, true);
      }
      if (destinationChanged && this.branchActive(destinationType, destinationParentID)) {
        const destinationRefresh = destinationType === 'questions'
          ? this.loadQuestions(destinationParentID, true)
          : this.loadSubQuestions(destinationParentID, true);
        return Promise.all([sourceRefresh, destinationRefresh]);
      }
      return sourceRefresh;
    },
    pruneRemovedBranches(type, previousItems, nextItems, preserveRemovedIDs = []) {
      const nextIDs = new Set(nextItems.map(item => item.id));
      const preservedIDs = new Set(preserveRemovedIDs.map(id => String(id)));
      previousItems
        .filter(item => !nextIDs.has(item.id) && !preservedIDs.has(String(item.id)))
        .forEach(item => {
          if (type === 'categories') {
            this.prunePollBranch(item.id);
          } else if (type === 'polls') {
            this.pruneQuestionBranch(item.id);
          } else if (type === 'questions') {
            this.$delete(this.branches.subQuestions, item.id);
          }
        });
    },
    prunePollBranch(categoryID) {
      const polls = this.branches.polls[categoryID];
      if (polls) {
        const preservedPollIDs = new Set(Object.keys(polls.preserveRemovedIDs));
        polls.items
          .filter(poll => !preservedPollIDs.has(String(poll.id)))
          .forEach(poll => this.pruneQuestionBranch(poll.id));
        this.$delete(this.branches.polls, categoryID);
      }
    },
    pruneQuestionBranch(pollID) {
      const questions = this.branches.questions[pollID];
      if (questions) {
        const preservedQuestionIDs = new Set(Object.keys(questions.preserveRemovedIDs));
        questions.items
          .filter(question => !preservedQuestionIDs.has(String(question.id)))
          .forEach(question => {
            this.$delete(this.branches.subQuestions, question.id);
          });
        this.$delete(this.branches.questions, pollID);
      }
    },
    createPollCategory() {
      return apiService.createGeneralPollCategoryAdmin({}).then(() => {
        return this.getCategories(true);
      });
    },
    createPoll(id) {
      return apiService.createGeneralPollAdmin({ "poll_category": id }).then(() => {
        return this.loadPolls(id, true);
      });
    },
    createPollQuestion(id) {
      return apiService.createGeneralPollQuestionAdmin({ "poll": id }).then(() => {
        return this.loadQuestions(id, true);
      });
    },

    createPollSubQuestion(id) {
      return apiService.createGeneralPollQuestionAdmin({ "parent_question": id }).then(() => {
        return this.loadSubQuestions(id, true);
      });
    },

  }
}
</script>
